import { render, staticRenderFns } from "./pst_course.vue?vue&type=template&id=6005186e&scoped=true"
import script from "./pst_course.vue?vue&type=script&lang=js"
export * from "./pst_course.vue?vue&type=script&lang=js"
import style0 from "./pst_course.vue?vue&type=style&index=0&id=6005186e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005186e",
  null
  
)

export default component.exports